import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';

interface LetContext<T> {
    im2mLet: T | null;
}

/**
 * Directive to assign locale variables in templates:
 *
 * import { IM2MCommonModule } from 'm2mgate-sage-ui
 *
 * @example
 * <div *im2mLet="example$ | async as example">
    <span>{{example}}</span>
 *  </div>
 */

@Directive({
    selector: '[im2mLet]',
})
export class LetDirective<T> {
    private _context: LetContext<T> = { im2mLet: null };

    constructor(_viewContainer: ViewContainerRef, _templateRef: TemplateRef<LetContext<T>>) {
        _viewContainer.createEmbeddedView(_templateRef, this._context);
    }

    @Input()
    set im2mLet(value: T) {
        this._context.im2mLet = value;
    }
}
